import '@sass/destination/destination.scss';
import '@module/Rating/Rating.js';
import '@module/LinkBox/LinkBox.js';
import { documentReady, getSearchBoxConfigFromUrl, getUrlVars, qs, qsa, setUrlParameter } from '@utils/toolbox';
import { PriceCutter } from '@module/PriceCutter/PriceCutter';
import { SearchBox } from '@module/SearchBox/SearchBox';
import { logShowresultClick } from '@utils/connectApiCalls';
import { trackEvent } from '@utils/googleDataLayer';
import BaseSpiderChart from '@/src/vue/components/Base/BaseSpiderChart.vue';
import { createVueApp } from '@/src/vue/utils/createVueApp';


const spiderChartElement = document.getElementById('spiderchart');

if (spiderChartElement && js_params?.spiderChartData) {
	createVueApp(BaseSpiderChart, { data: js_params.spiderChartData }).mount('#spiderchart');
}


const trackEvents = function () {
	const pathArray = window.location.pathname.split('/');

	let fb_country,
		fb_city;

	if (pathArray[2] == '') {
		fb_country = '';
		fb_city = pathArray[1];
	} else {
		fb_country = pathArray[1];
		fb_city = pathArray[2];
	}

	/**
		 var fb_country = js_params.productCatalogIdCity;
		 var fb_city = js_params.productCatalogIdCountry;
		 **/

	trackEvent.destinationInfo(fb_country, fb_city, js_params.productCatalogIdCountry, js_params.productCatalogIdCity);
};

const init = function () {
	window.searchBox = new SearchBox({
		id: 'abSearchBox',
		calendarRender: document.getElementById('dateselector'),
		config: getSearchBoxConfigFromUrl(js_params.urlVars),
		callbacks:
		{
			onPreviewReceived: function (instance, previewGroup) {
				if (previewGroup?.flights?.length) {
					instance.cancelSearch();
					location.href = instance.showresultURL;
				}
			},
			onSearchComplete: (instance) => {
				const urlVars = getUrlVars();

				if (instance.data.forceNearbyDates) {
					instance.showresultURL = setUrlParameter(instance.showresultURL, 'forceNearbyDates', 1);
				}

				if (urlVars?.filter) {
					instance.showresultURL = setUrlParameter(instance.showresultURL, 'filter', urlVars.filter);
				}

				location.href = instance.showresultURL;
			}
		}
	});

	// Show selected month in country page
	qs('#month-price-selector.country')?.addEventListener('change', function ({ target }) {
		qsa('#month-all > div').forEach(element => element.classList.add('hidden'));
		qs(`#${target.value}`).classList.remove('hidden');
	});

	// Show selected month in city page
	qs('#month-price-selector.city')?.addEventListener('change', function ({ target: { value } }) {
		qsa('#month-all [data-month]').forEach(element => element.classList.add('hidden'));
		qsa(`#month-all [data-month="${value}"]`)?.forEach(element => element.classList.remove('hidden'));
	});

	// Show selected city in city page
	qs('#location-selector')?.addEventListener('change', function ({ target: { value } }) {
		qsa('#month-all [data-city]').forEach(element => element.classList.add('hidden'));
		qsa(`#month-all [data-city="${value}"]`)?.forEach(element => element.classList.remove('hidden'));
	});

	if (typeof PRICECUTTER !== 'undefined') {
		this.priceCutter = new PriceCutter();
		// PRICECUTTER.setBoxDisplay(elem);
		// PRICECUTTER.estimate(elem.data('iatafrom'), elem.data('iatato'), elem.data('leavedate'), elem.data('homedate'), 1, 1, [], 0);
	}

	trackEvents();

	logShowresultClick('showresult_click');
};

documentReady(init);
